// PDF rendering geometry — shared between viewers and docs annotation layers

export type PdfPageMetrics = {
  originalPageWidth: number;
  originalPageHeight: number;
};

// Layout constants for PDF virtual scroll — consumed by PdfMainViewer and ShapeOverlay
export const PAGE_GAP = 24;
export const PAGE_TOP_PADDING = 32;
